const invoicesPT = {
    "view": {
        "table": {
            "title": "Sua lista de Faturas",
            "column": {
                "issueDate": "Data de Emissão",
                "invoiceNumber": "Número da Fatura",
                "status": "Status",
                "totalAmount": "Valor Total",
                "downloadPDF": "Baixar PDF",
                "whtStatement": "Declaração de WHT"
            },
            "label": {
                "notApplicable": "Não Aplicável"
            },
            "placeholder": {
                "search": "Pesquisar..."
            },
            "button": {
                "download": "Baixar",
                "exportCSV": "Exportar CSV"
            }
        },
        "message": {
            "cantAddInvoices": "Infelizmente, você não pode adicionar faturas no momento. Ou seus dados fiscais ou de conta de pagamento não estão totalmente completos. Para desbloquear este recurso, entre em contato com nossa equipe de suporte.",
            "invoicingNotAvailable": "Gere faturas do 3º ao 22º dia de cada mês. Observe que a geração de faturas não é possível do 23º ao 2º dia do mês seguinte, pois durante este período são processados pagamentos automáticos. Obrigado pela sua compreensão.",
            "generatingInvoices": "Você não pode adicionar faturas no momento, pois há faturas sendo geradas. Por favor, verifique novamente mais tarde.",
            "noAccess": "Você não tem acesso a este módulo, entre em contato com a equipe de suporte para mais informações.",
            "subscriptionExpired": "Sua assinatura expirou. Por favor, <1>retome</1> sua assinatura para utilizar este recurso.",
            "subscriptionUpgrade": "Seu plano de assinatura atual não suporta este recurso. Por favor, <1>atualize</1> seu plano de assinatura para utilizar este recurso."
        }
    },
    "add": {
        "title": "Adicionar Fatura",
        "form": {
            "table": {
                "statements": {
                    "title": "Declarações disponíveis para faturamento"
                }
            },
            "button": {
                "generateInvoice": "Gerar Fatura"
            }
        },
        "message": {
            "success": "Fatura foi adicionada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!",
            "noStatementAvailable": "Nenhuma declaração disponível para faturamento.",
            "invoicingLimitNotReached": "Você não pode adicionar faturas no momento, pois o total a pagar é menor ou igual a <strong>0€</strong>."
        },
        "modal": {
            "header": "Adicionar Fatura",
            "body": "Tem certeza de que deseja criar fatura para as Declarações atualmente ABERTAS?"
        }
    }
};

export default invoicesPT;